import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { ALERTS } from 'app/@common/constants'
import { SelectLoading } from "app/components/loading"


export default function SelectAlerts({ ...props }) {

    if (!props.date || !props.alertType) return <SelectLoading />

    const myProps = {
        urlAjax: `${ALERTS.SELECT}/${props.alertType}`,
        placeholder: i18n.t('alerts:selectAlert'), 
        isClearable: true, 
        icon: { icon: 'bell' },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}